import { motion } from "framer-motion";
import { WHY_ITEMS } from "@/components/vss/data";

export default function WhyVSS() {
  return (
    <section
      id="why"
      className="relative py-28 sm:py-36 border-t border-slate-200"
      data-testid="why-section"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid grid-cols-12 gap-6 mb-14">
          <div className="col-span-12 lg:col-span-7">
            <div className="mb-3 font-mono-a text-[11px] uppercase tracking-[0.28em] text-teal-700">
              / 006 · Why Visionary
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 tracking-tight leading-[1.05]">
              The strategic talent
              <br />
              <span className="font-serif-a italic font-normal text-slate-500">
                advantage we build.
              </span>
            </h2>
          </div>
          <div className="col-span-12 lg:col-span-5">
            <p className="text-slate-600 text-base sm:text-lg leading-relaxed">
              Transitioning recruitment from a cost-of-fill line item into a
              strategic edge — where quality-of-hire, retention, and business
              impact become the measured outcomes.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-4">
          {WHY_ITEMS.map((w, i) => (
            <motion.div
              key={w.idx}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-10% 0px" }}
              transition={{ delay: i * 0.08, duration: 0.7, ease: "easeOut" }}
              className="vss-card col-span-12 sm:col-span-6 lg:col-span-3 p-8 min-h-[240px] flex flex-col"
              data-testid={`why-card-${w.idx}`}
            >
              <div className="number-stroke text-5xl sm:text-6xl mb-6">
                {w.idx}
              </div>
              <div className="font-display text-xl font-bold text-slate-900">
                {w.title}
              </div>
              <p className="mt-3 text-slate-600 text-sm leading-relaxed">
                {w.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
